// extracted by mini-css-extract-plugin
export default {"base":"vp_D5GDX","reset":"vp_o7YVg"};